<mat-card class="personal-info-card tagus-card">
    <mat-card-content>
        <div class="row">
            <ng-container>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <button mat-fab class="tagus">
                        <mat-icon>check_circle_outline</mat-icon>
                    </button>
                </div>
                <div class="col-lg-9 col-md-9 col-sm-9">
                    <h4>Call Connected</h4>
                    <h6>calling...</h6>
                </div>
            </ng-container>
        </div>
    </mat-card-content>
</mat-card>